import React from "react";

import {
  fitVideoExportProfile,
  VIDEO_EXPORT_PROFILE_LIST,
  type VideoExportProfileId,
} from "libs/videoExportProfiles";

export function VideoResolutionSelect({
  value,
  onChange,
  sourceSize,
}: {
  value: VideoExportProfileId;
  onChange: (value: VideoExportProfileId) => void;
  sourceSize: {width: number; height: number};
}) {
  return (
    <>
      <label htmlFor="video-resolution">Resolution:</label>
      <select
        className="video-resolution"
        id="video-resolution"
        value={value}
        onChange={(event) => onChange(event.target.value as VideoExportProfileId)}
      >
        {VIDEO_EXPORT_PROFILE_LIST.map((profile) => {
          const output = fitVideoExportProfile(sourceSize, profile);
          return (
            <option key={profile.id} value={profile.id}>
              {profile.label} ({output.width}×{output.height})
            </option>
          );
        })}
      </select>
    </>
  );
}
